<template>
  <div class="bio_look">
    <div class="look_img">
      <div>
        <img style="width:100%" src="https://www.bioflin.com:83/image/bio_look/bioLook2.jpg" alt />
      </div>
      <div class="img_cla">
        <div class="head">防疫急缺物资</div>
        <div class="list clearfix">
          <div
            class="list_cla"
            v-for="(item) in classIfy"
            :key="item.id"
            @click="select(item.id)"
          >
            <div class="list_left">
              <p style="font-size:18px;font-weight: bold;">{{item.name}}</p>
              <p>{{item.number}}条</p>
            </div>
            <div class="list_right">
              <img :src="item.image" alt />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="look_conent">
      <div class="patent_class">
        <span class="patent_class_span">分类:</span>
        <el-button @click="select(0)" :class="status === 0? 'btn_active' : ''" type="text">全部</el-button>
        <el-button v-for="item in classIfy" :key="item.id" @click="select(item.id)" :class="status === item.id? 'btn_active' : ''" type="text">{{item.name}}</el-button>
        <!-- <el-button @click="select(2)" :class="status === 2? 'btn_active' : ''" type="text">防护面罩/眼镜</el-button>
        <el-button @click="select(3)" :class="status === 3? 'btn_active' : ''" type="text">防护服</el-button>
        <el-button @click="select(4)" :class="status === 4? 'btn_active' : ''" type="text">防护配件</el-button>
        <el-button @click="select(5)" :class="status === 5? 'btn_active' : ''" type="text">体温枪</el-button>
        <el-button @click="select(6)" :class="status === 6? 'btn_active' : ''" type="text">其他物资</el-button> -->
      </div>
      <div class="content">
        <div class="list" v-for="item in Look_list" :key="item.id">
          <div class="list_top"  @click="product_details(item.id)">
            <div class="list_img">
              <img :src="item.image" alt />
            </div>
            <div class="list_details">
              <h4>{{item.title}}</h4>
              <p style="font-size:12px;color:#999">{{item.create_date}} 发布</p>
              <p>产品 : {{item.product_title}}</p>
              <p>标准 ：{{item.standard}}</p>
              <p>数量 ：{{item.number}}</p>
              <p>场景 ： {{item.use_sence}}</p>
            </div>
          </div>
          <div class="list_btn">
            <div>
              <el-button type="success" @click="product_details1(item.id)">我要供货</el-button>
              <el-button type="primary" @click="product_details(item.id)">查看详情</el-button>
            </div>
          </div>
        </div>

        <div class="page">
          <el-pagination
            background
            layout="total,prev, pager, next"
            @current-change="setpage"
            hide-on-single-page
            :total="total"
          ></el-pagination>
        </div>
        <div v-if="Look_list.length===0" style="text-align:center;font-size:20px;height:200px">暂无信息</div>
      </div>
      <div style="height:20px"></div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serve: this.$store.state.serve,
      status: 0,
      classIfy: [],
      Look_list: [],
      total: 0,
      page: 0,
    };
  },
  activated() {
    this.$store.commit("set_top_nav", "10");
  },
  created() {
    this.classify();
    this.geting();
  },
  methods: {
    product_details1(id){
      this.$router.push('/bioLook_updata?id=' + id + '&a=' + Math.round(Math.random()*100) )
    },
    product_details(id){
      this.$router.push('/bioLook_details?id=' + id)
    },
    setpage(page) {
      this.page = page;
      this.geting();
    },
    classify() {
      this.axios.get(this.serve + "/supplyCateList").then(res => {
        if (res.data.status === "success") {
          this.classIfy = res.data.data;
        }
      });
    },
    geting() {
      this.axios
        .get(this.serve + "/supplyList", {
          params: {
            category: this.status,
            page: this.page,
            pc : 1
          }
        })
        .then(res => {
          if (res.data.status === "success") {
            this.Look_list = res.data.data.results;
            this.page = res.data.data.page;
            this.total = res.data.data.total;
          }
        });
    },
    select(e) {
      this.status = e;
      this.geting();
    }
  }
};
</script>

<style lang="scss">
.clearfix:after {
  content: "";
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.bio_look {
  width: 1200px;
  margin: 0 auto;
  .look_img {
    position: relative;
    .img_cla {
      width: 96%;
      height: 400px;
      background: #fff;
      position: absolute;
      left: 20px;
      bottom: 20px;
      .head {
        height: 60px;
        line-height: 60px;
        padding-left: 10px;
        font-weight: bold;
        font-size: 20px;
        border-bottom: 1px solid #f2f2f2;
      }
      .list {
        margin: 0 auto;
        .list_cla {
          width: 49%;
          padding-left: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #f2f2f2;
          border-right: 1px solid #f2f2f2;
          float: left;
          cursor: pointer;
          .list_left {
          }
          .list_right {
            img {
              width: 60px;
              height: 60px;
            }
          }
        }
      }
    }
  }
  .look_conent {
    .patent_class {
      width: 100%;
      background: #fff;
      height: 40px;
      margin-top: 21px;
      .patent_class_span {
        font-size: 14px;
        font-family: "Microsoft YaHei";
        padding-left: 9px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
      }
      button {
        margin-left: 40px;
        color: #333333;
      }
      button:hover {
        color: #e2211c;
      }
      .btn_active {
        color: #e2211c;
        border-bottom: 2px solid #e2211c;
      }
    }
    .content {
      margin-top: 20px;
      .page {
        text-align: right;
      }
      .list {
        background: #fff;
        padding: 0 10px;
        cursor: pointer;
        .list_top {
          display: flex;
          border-bottom: 1px solid #f2f2f2;
          .list_img {
            img {
              width: 60px;
              height: 60px;
            }
          }
          .list_details {
            margin-left: 20px;
          }
        }
        .list_btn {
          text-align: right;
          margin: 10px 0;
          padding: 10px 0;
        }
      }
    }
  }
}
</style>